import { render, staticRenderFns } from "./reviewArea.vue?vue&type=template&id=118dfd18&"
import script from "./reviewArea.vue?vue&type=script&lang=js&"
export * from "./reviewArea.vue?vue&type=script&lang=js&"
import style0 from "./reviewArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports